export const PAGE_HEADER_SIZE = 52;
export const PAGE_HEADER_SIZE_STRING = `${PAGE_HEADER_SIZE}px`;

/**
 * The page-header height as Tailwind classes, for `className` consumers.
 *
 * Written out as literals rather than interpolated from {@link PAGE_HEADER_SIZE_STRING}, because
 * Tailwind's scanner reads source text statically: a class assembled at runtime — `` h-[${size}] `` —
 * is never emitted, so the height silently does not apply. Use this when styling via `className`, and
 * `PAGE_HEADER_SIZE_STRING` when setting an inline `style` height, where interpolation is fine.
 *
 * Keep the pixel values here in sync with `PAGE_HEADER_SIZE` above.
 */
export const PAGE_HEADER_HEIGHT_CLASSES = "min-h-[52px] h-[52px]";
